import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Case } from '../../shared/models/case';
import {
    BaseHttpService,
    Query,
    Update,
    Create,
    Delete,
    UriBuilderParams
} from './base/base-http.service';
import { HttpServiceBundle } from './base/http-service-bundle.service';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { SMPComment } from '@app/shared/models/comment';
import { BaseWithIdList } from '@app/shared/models/list';

export class CaseCommentsUriBuilderParams extends UriBuilderParams<SMPComment> {

    private readonly _case: string;

    get case() {
        return this._case;
    }

    constructor(caseX?: Case | string, comment?: SMPComment | string) {
        super(comment);
        this._case = this.getParamId(caseX);
    }

    public buildUri(): string {
        const uri = `/${BackendUriUnits.CASES}/${this.case}${this.simpleUriBuild(BackendUriUnits.COMMENTS)}`;
        return uri;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaseCommentsService extends BaseHttpService<SMPComment, CaseCommentsUriBuilderParams>
                                 implements Query<SMPComment, CaseCommentsUriBuilderParams>,
                                            Create<SMPComment, CaseCommentsUriBuilderParams>,
                                            Update<SMPComment, CaseCommentsUriBuilderParams>,
                                            Delete<SMPComment, CaseCommentsUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(SMPComment, httpServiceBundle);
    }

    // BASE METHODS ****************************************************************************************

    public query(uriParams: CaseCommentsUriBuilderParams): Observable<BaseWithIdList<SMPComment>> {
        return this.queryBase(uriParams)
                   .pipe(map(result => BaseWithIdList.upgradeFromBaseList(result)));
    }

    public create(uriParams: CaseCommentsUriBuilderParams, toCreate: SMPComment): Observable<SMPComment> {
        return this.createBase(uriParams, toCreate);
    }

    public update(uriParams: CaseCommentsUriBuilderParams, toUpdate: SMPComment): Observable<SMPComment> {
        return this.updateBase(uriParams, toUpdate);
    }

    public delete(uriParams: CaseCommentsUriBuilderParams): Observable<boolean> {
        return this.deleteBase(uriParams);
    }

}
